// Module
var code = "<div ng-class=\"{ processing : frameLoading }\" class=\"flex-none\"><div></div></div> <iframe id=\"reportFrame\" ng-show=\"vm.src\" ng-src=\"{{vm.src}}\" frameborder=\"0\"> </iframe> ";
// Exports
module.exports = code;